export const MENU_MANIFEST = Object.freeze([
  {
    key: 'general',
    title: 'General',
    items: [
      { key: 'dashboard', label: 'Dashboard', route: '/dashboard' },
      { key: 'dashboard sofia', label: 'Sofia Dashboard', route: '/dashboard-sofia-edition' },
      { key: 'dashboard sofia fullscreen', label: 'Sofia Wallboard', route: '/dashboard-sofia-edition-live' },
      { key: 'weekly report', label: 'Weekly Report', route: '/weekly-report' },
      { key: 'inactive escalation', label: 'Inactive SLA', route: '/inactive-escalation' },
      { key: 'mail tracking', label: 'Email Tracking', route: '/mail-tracking-v2' },
      { key: 'simulation results', label: 'Simulation Results', route: '/simulation-results' },
      { key: 'contacts', label: 'Contacts', route: '/contacts' },
      { key: 'stats', label: 'Stats', route: '/dashboardStatus' },
      { key: 'audit activity', label: 'Одит — активност', route: '/audit-v2' },
      { key: 'audit access', label: 'Одит — достъп', route: '/access-audit-logs' },
    ],
  },
  {
    key: 'devices',
    title: 'Devices',
    items: [
      { key: 'devices', label: 'Devices', route: '/devices' },
      { key: 'pmi devices', label: 'PMI Devices', route: '/pmi-devices' },
      { key: 'pmi devices p', label: 'PMI Devices P', route: '/pmi-devicesP' },
      { key: 'pmi devices v2', label: 'PMI Devices (v2)', route: '/pmi-devices-v2' },
      { key: 'my devices', label: 'My Devices', route: '/my-devices' },
      { key: 'locations', label: 'Locations', route: '/locations' },
      { key: 'pmi locations', label: 'PMI Locations', route: '/pmi-locations' },
      { key: 'pmi locations v2', label: 'PMI Locations (v2)', route: '/pmi-locations-v2' },
      { key: 'pmi mapping log', label: 'PMI Mapping Log', route: '/pmi-mapping-log' },
      { key: 'ta&tal addresses', label: 'TA&TAL Addresses', route: '/ta-tal-addresses' },
      { key: 'pmi device logs', label: 'PMI devices logs', route: '/pmi-device-logs' },
      { key: 'notify flow', label: 'Notify Flow (proto)', route: '/notify-flow-v2' },
      { key: 'device notifications', label: 'Device Notifications', route: '/device-notifications-v2' },
      { key: 'location health', label: 'Location Health', route: '/location-health-v2' },
      { key: 'qa cycle', label: 'QA цикъл', route: '/qa-cycle-v2' },
      { key: 'qa simulations', label: 'QA симулации', route: '/qa-simulations-v2' },
      { key: 'device watch', label: 'Наблюдение', route: '/device-watch-v2' },
      { key: 'device observation logs', label: 'Логове (наблюдение)', route: '/device-observation-v2' },
    ],
  },
  {
    key: 'campaigns',
    title: 'Campaigns',
    items: [
      { key: 'campaign previews', label: 'Campaign previews', route: '/campaign-previews' },
      { key: 'campaign', label: 'Campaign', route: '/campaigns' },
      { key: 'campaigns', label: 'Campaigns', route: '/campaignsP' },
      { key: 'campaign assignments', label: 'Campaign Assignments', route: '/manual-campaign-assignment' },
      { key: 'categories schedule', label: 'Scheduled Playback', route: '/schedule' },
      { key: 'campaign calendar', label: 'Campaign Calendar (proto)', route: '/campaign-calendar-v2' },
      { key: 'campaign devices logs', label: 'Campaign assignment logs (legacy)', route: '/campaign-device-logs' },
      { key: 'campaign edit logs', label: 'Campaign change logs', route: '/campaign-change-logs' },
    ],
  },
  {
    key: 'content',
    title: 'Content',
    items: [
      { key: 'upload content', label: 'Upload Content', route: '/upload-content' },
      { key: 'files', label: 'Files', route: '/list-files' },
      { key: 'files v2', label: 'Files (v2)', route: '/list-files-v2' },
      { key: 'products', label: 'Products', route: '/products' },
      { key: 'imports', label: 'Imports', route: '/imports' },
      { key: 'import', label: 'Import File', route: '/import' },
      { key: 'categories', label: 'Categories', route: '/categories' },
      { key: 'file edit logs', label: 'File edit logs', route: '/file-edit-logs' },
      { key: 'proof of play', label: 'Proof of Play', route: '/proof-of-play' },
      { key: 'proof of play map', label: 'Proof of Play Map', route: '/proof-of-play-live' },
    ],
  },
  {
    key: 'help',
    title: 'Help',
    items: [
      { key: 'instructions', label: 'Instructions', route: '/instructions' },
      { key: 'instructions bg', label: 'Инструкции', route: '/instructionsNew' },
      { key: 'executive summary', label: 'Executive Summary', route: '/executive-summary' },
      { key: 'feedback board', label: 'Feedback Board', route: '/feedback-board' },
      { key: 'field instructions', label: 'Field Instructions', route: '/field-instructions' },
      { key: 'change log', label: 'Change log', route: '/change-log' },
    ],
  },
  {
    key: 'settings',
    title: 'Settings',
    items: [
      { key: 'access control', label: 'Access Control', route: '/access-control' },
      { key: 'access audit logs', label: 'Одит — достъп', route: '/access-audit-logs-v2' },
      { key: 'roles & permissions', label: 'Роли и права', route: '/roles-permissions-v2' },
      { key: 'server health', label: 'Server Health', route: '/server-health' },
      { key: 'pmi runtime controls', label: 'PMI Runtime Controls', route: '/pmi-runtime-controls' },
      { key: 'device configs', label: 'Device Configs', route: '/device-configs-v2' },
      { key: 'page analytics', label: 'Page Analytics', route: '/page-analytics-v2' },
    ],
  },
]);

// v1 → v2 route pairs. When the UI-version toggle is on 'v2', nav links to the v1 route on the
// left resolve to the v2 route on the right; pages with no entry here keep their v1 route (graceful
// fallback). Keep this list as the single source of truth as pages get their v2 version.
export const V2_ROUTE_MAP = Object.freeze({
  '/pmi-devicesP': '/pmi-devices-v2',
  '/pmi-devices': '/pmi-devices-v2',
  '/pmi-locations': '/pmi-locations-v2',
  '/list-files': '/list-files-v2',
  '/contacts': '/contacts-v2',
  '/access-audit-logs': '/access-audit-logs-v2',
});

// Routes that are the *target* of a v2 pair — these are the standalone "(v2)" menu duplicates that
// should be hidden while the toggle is on 'v2' (the base item already resolves to them).
export const V2_TARGET_ROUTES = Object.freeze(new Set(Object.values(V2_ROUTE_MAP)));

// v2 → canonical v1 route (reverse of V2_ROUTE_MAP). Used by the header toggle to navigate back to
// the v1 page. When several v1 routes map to one v2 target, this picks the canonical one.
export const V1_ROUTE_MAP = Object.freeze({
  '/pmi-devices-v2': '/pmi-devicesP',
  '/pmi-locations-v2': '/pmi-locations',
  '/list-files-v2': '/list-files',
  '/contacts-v2': '/contacts',
  '/access-audit-logs-v2': '/access-audit-logs',
});

// The counterpart of `route` in the target UI version, or null when the current page has no
// counterpart (e.g. Campaigns has no v2). Used to navigate the user on toggle.
export const counterpartRoute = (route, targetVersion) =>
  targetVersion === 'v2' ? (V2_ROUTE_MAP[route] || null) : (V1_ROUTE_MAP[route] || null);

// Resolve a nav route for the active UI version. v2 mode swaps to the paired v2 route when one
// exists; otherwise (and always in v1 mode) returns the route unchanged.
export const resolveNavRoute = (route, uiVersion) =>
  (uiVersion === 'v2' && V2_ROUTE_MAP[route]) ? V2_ROUTE_MAP[route] : route;

// True when `route` has a v2 pair (so the item can show a "v2" badge in v2 mode).
export const hasV2Variant = (route) => Boolean(V2_ROUTE_MAP[route]);

// True when a menu item should be hidden in v2 mode because it's the standalone "(v2)" duplicate
// of a base item that now resolves to it.
export const isV2DuplicateRoute = (route) => V2_TARGET_ROUTES.has(route);

export const flattenMenuManifest = () =>
  MENU_MANIFEST.flatMap((section) =>
    (section.items || []).map((item) => ({
      sectionKey: section.key,
      sectionTitle: section.title,
      ...item,
    }))
  );
